import { render, staticRenderFns } from "./ReportCardPieChart.vue?vue&type=template&id=75da8833&scoped=true"
import script from "./ReportCardPieChart.vue?vue&type=script&lang=ts"
export * from "./ReportCardPieChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75da8833",
  null
  
)

export default component.exports